import { useCallback, useEffect, useState } from 'react';
import { Button } from '../../components/Button';
import { Icon } from '../../components/Icon';
import { api, type AccountSession } from '../../lib/api';
import { useStore } from '../../store/StoreProvider';
import { SettingsBlock } from './SettingsBlock';

// Impostazioni › Sessioni (tela, artboard 47): le sessioni aperte di chi è entrato. Quella in
// uso non si chiude da qui: per quella c'è «Esci». La password è passata nel profilo (0.1.28).
export function browserLabel(agent: string): string {
  if (!agent) return 'Browser sconosciuto';
  const browser = /Edg\//.test(agent)
    ? 'Edge'
    : /Firefox\//.test(agent)
      ? 'Firefox'
      : /Chrome\//.test(agent)
        ? 'Chrome'
        : /Safari\//.test(agent)
          ? 'Safari'
          : 'Browser';
  const os = /iPhone|iPad/.test(agent)
    ? 'iPhone o iPad'
    : /Android/.test(agent)
      ? 'Android'
      : /Mac OS X/.test(agent)
        ? 'macOS'
        : /Windows/.test(agent)
          ? 'Windows'
          : /Linux/.test(agent)
            ? 'Linux'
            : '';
  return os ? `${browser} · ${os}` : browser;
}

function opened(at: number | null): string {
  if (!at) return 'aperta prima di questa versione';
  return `aperta il ${new Date(at * 1000).toLocaleString('it-IT', { dateStyle: 'medium', timeStyle: 'short' })}`;
}

export function AccessTab() {
  const { toast } = useStore();
  const [rows, setRows] = useState<AccountSession[] | null>(null);
  const load = useCallback(() => {
    api
      .accountSessions()
      .then(setRows)
      .catch(() => setRows([]));
  }, []);
  useEffect(load, [load]);

  const close = (id: string | null) => {
    (id ? api.closeSession(id) : api.closeOtherSessions())
      .then((r) => {
        toast({
          kind: 'success',
          title: r.closed === 1 ? 'Sessione chiusa' : `${r.closed} sessioni chiuse`,
        });
        load();
      })
      .catch((e: Error) => toast({ kind: 'danger', title: 'Non chiusa', body: e.message }));
  };
  const others = (rows ?? []).filter((r) => !r.current).length;

  return (
    <SettingsBlock
      over="Accesso"
      title={`Le tue sessioni aperte${rows ? ` · ${rows.length}` : ''}`}
      hint="Una sessione dura 30 giorni. Chiudere quella di un dispositivo perso lo scollega subito. Password e passkey stanno nel tuo profilo."
      control={
        others > 0 && (
          <Button size="sm" onClick={() => close(null)}>
            Chiudi le altre
          </Button>
        )
      }
    >
      <div style={{ display: 'grid', gap: 8 }}>
        {(rows ?? []).map((r) => (
          <div key={r.id} className="settings-row">
            <Icon name="monitor" size={18} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div className="t-strong">{browserLabel(r.agent)}</div>
              <div className="t-caption faint">{opened(r.createdAt)}</div>
            </div>
            {r.current ? (
              <span className="settings-badge">questa</span>
            ) : (
              <Button size="sm" onClick={() => close(r.id)}>
                Chiudi
              </Button>
            )}
          </div>
        ))}
      </div>
    </SettingsBlock>
  );
}
